// CapabilityCards.jsx - What You Can Do (Capabilities, Not Features)
import React from 'react';
import './CapabilityCards.css';

const CAPABILITIES = [
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <circle cx="8.5" cy="8.5" r="1.5" />
        <path d="m21 15-5-5L5 21" />
      </svg>
    ),
    title: 'Generate Images',
    description: 'From a prompt to studio-grade visuals.',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M12 20h9" />
        <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
      </svg>
    ),
    title: 'Edit Images with Prompts',
    description: 'Change style, background, details.',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="m22 8-6 4 6 4V8Z" />
        <rect width="14" height="12" x="2" y="6" rx="2" />
      </svg>
    ),
    title: 'Create Videos',
    description: 'Turn images into short clips.',
  },
];

const CapabilityCards = () => {
  return (
    <section className="landing-section capabilities-section">
      <div className="capabilities-stack">
        {CAPABILITIES.map((cap, index) => (
          <div key={index} className="capability-card">
            <div className="capability-icon">{cap.icon}</div>
            <div className="capability-text">
              <h3 className="capability-title">{cap.title}</h3>
              <p className="capability-description">{cap.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CapabilityCards;
